import { useBackend } from "../../services";
import { AlbumIdentifierType } from "./interfaces";

export const useAddAlbumIdentifier = () => {
  const { post } = useBackend();
  const addAlbumIdentifier = (parameters: IAddAlbumIdentifierParameters) =>
    post("albumIdentifiers", parameters);
  return { addAlbumIdentifier };
};

export interface IAddAlbumIdentifierParameters {
  albumId: string;
  labelId?: string;
  codeParts: string[];
  description?: string;
  type: AlbumIdentifierType;
}
